export default {
  loggedIn({ token }) {
    return !!token
  }
}
